module.exports = "<p>\n  dashboard works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/globant/site/src/app/components/dashboard/dashboard.component.html
// module id = ../../../../../src/app/components/dashboard/dashboard.component.html
// module chunks = main